import { render, staticRenderFns } from "./SignaturePlans.vue?vue&type=template&id=815aac06"
import script from "./SignaturePlans.vue?vue&type=script&lang=js"
export * from "./SignaturePlans.vue?vue&type=script&lang=js"
import style0 from "./SignaturePlans.vue?vue&type=style&index=0&id=815aac06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports